module.exports = __webpack_public_path__ + "img/autobus-galland.85da9e67.webp";